import { render, staticRenderFns } from "./TalkRule.vue?vue&type=template&id=2aec331e&scoped=true&"
import script from "./TalkRule.vue?vue&type=script&lang=js&"
export * from "./TalkRule.vue?vue&type=script&lang=js&"
import style0 from "./TalkRule.vue?vue&type=style&index=0&id=2aec331e&prod&lang=scss&scoped=true&"
import style1 from "./TalkRule.vue?vue&type=style&index=1&id=2aec331e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec331e",
  null
  
)

export default component.exports